import { useHelpCenterTFunction } from '@retail/help-center/i18n';
import { useArticleSearch } from '@retail/sanity/data-access';
import { List, Stack, Typography } from '@mui/material';
import { LinkStyledListItem, TanstackQueryLoadingWrapper } from '@shared/components';
import React, { useState } from 'react';
import { useDebounce } from 'use-debounce';
import { SearchInput } from '@retail/help-center/components';
import { ArticleMinimal } from './CategoryArticlesContainer';
import { useConsumerType, useSanityLanguageCode } from '@retail/sanity/hooks';

interface Props {
  onArticleClick: (article: ArticleMinimal) => void;
}

export const SearchContainer: React.FC<Props> = ({ onArticleClick }) => {
  const t = useHelpCenterTFunction();
  const language = useSanityLanguageCode();
  const [searchText, setSearchText] = useState('');
  const [debouncedSearchText] = useDebounce(searchText, 400);
  const consumerType = useConsumerType();

  const articleSearchLoadingState = useArticleSearch({
    language,
    searchText: debouncedSearchText,
    consumer: consumerType,
  });

  return (
    <Stack px={2} spacing={2} mt={2}>
      <SearchInput value={searchText} onChange={setSearchText} />

      {/*@ts-ignore*/}
      <TanstackQueryLoadingWrapper loadingState={articleSearchLoadingState}>
        {(articles) => {
          if (articleSearchLoadingState.isSuccess && !articles.length) {
            return <Typography>{t('helpCenter.noResults')}</Typography>;
          }
          return (
            <List>
              {articles.map((article) => (
                <LinkStyledListItem onClick={() => onArticleClick(article)} key={article.slug}>
                  {article.title}
                </LinkStyledListItem>
              ))}
            </List>
          );
        }}
      </TanstackQueryLoadingWrapper>
    </Stack>
  );
};
